import useRefreshingAd from 'lib/hooks/useRefreshingAd';
import AdConfig from 'types/AdConfig';
import Container from './Container';

interface Props {
  adConfig: Omit<AdConfig, 'elementId'>;
  size?: string;
  className?: string;
  load?: boolean;
  placeholderSize?: number[];
  refreshTime: number;
  refreshLimit: number;
}

export default function RefreshingAd({
  placeholderSize = [],
  adConfig,
  className,
  load = true,
  refreshTime,
  refreshLimit,
}: Props): JSX.Element {
  const { elementId, isShown } = useRefreshingAd(adConfig, load, refreshTime, refreshLimit);
  const screenSizes = adConfig.screenSizes || [];

  return (
    <Container
      className={className}
      elementId={elementId}
      placeholderSize={placeholderSize}
      isShown={isShown}
      screenSizes={screenSizes}
    />
  );
}
